jQuery(document).ready(function() {
    initBg();
});

jQuery(window).on('load', function() {
    sk_space();
    initBg();
});

jQuery(window).on('resize', function() {
    sk_space();
    initBg();
});

jQuery(window).on('scroll', function() {
    if (jQuery(window).scrollTop() >= 100) {
        jQuery('.header-part').addClass('sticky');
    } else {
        jQuery('.header-part').removeClass('sticky');
    }

    if (jQuery(window).scrollTop() >= 800) {
        jQuery('.scroll-top').addClass('sticky');
    } else {
        jQuery('.scroll-top').removeClass('sticky');
    }
});

function initBg() {
    jQuery('.banner-bg').each(function() {
        var background = jQuery(this).data('background');
        jQuery(this).css( 'background-image', 'url("' + background + '")' );
    });
}

function sk_space(){
    if( jQuery('.sk-space-module').length > 0 ){
        jQuery('.sk-space-module').each(function() {
            var $self = jQuery(this),
                units = $self.data('units'),
                wide_width = parseInt(jQuery(window).width()),
                screen_wide_resolution = parseInt($self.data('wide_resolution')),
                screen_wide_space_size = parseInt($self.data('wide_size')),
                screen_normal_resolution = parseInt($self.data('normal_resolution')),
                screen_normal_space_size = parseInt($self.data('normal_size')),
                screen_tablet_resolution = parseInt($self.data('tablet_resolution')),
                screen_tablet_space_size = parseInt($self.data('tablet_size')),
                screen_mobile_resolution = parseInt($self.data('mobile_resolution')),
                screen_mobile_space_size = parseInt($self.data('mobile_size'));
            
            if( units == '%' ){
                screen_normal_space_size = screen_wide_space_size * screen_normal_space_size / 100;
                screen_tablet_space_size = screen_wide_space_size * screen_tablet_space_size / 100;
                screen_mobile_space_size = screen_wide_space_size * screen_mobile_space_size / 100;
            }

            if( wide_width >= screen_wide_resolution ){
                $self.css( 'height', screen_wide_space_size );
            } else if( wide_width >= screen_normal_resolution && wide_width < screen_wide_resolution ){
                $self.css( 'height', screen_normal_space_size );
            } else if( wide_width >= screen_tablet_resolution && wide_width < screen_normal_resolution ){
                $self.css( 'height', screen_tablet_space_size );
            } else if( wide_width >= screen_mobile_resolution  && wide_width < screen_tablet_resolution ){
                $self.css( 'height', screen_mobile_space_size );
            } else if( screen_mobile_resolution >= wide_width ){
                $self.css( 'height', screen_mobile_space_size );
            }
        });
    }
};